import { Flex, StyleSystemProps, styled } from '@withjoy/joykit';
import { pxToRem } from '@withjoy/joykit/theme';

export const RangeInputContainer = styled(Flex)`
  /* Remove input arrows in Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  /* Remove input arrows in Firefox */
  input[type='number'] {
    -moz-appearance: textfield;
  }
`;

const containerStyles: StyleSystemProps = {
  alignItems: 'end'
};

const separatorStyles: StyleSystemProps = {
  justifyContent: 'center',
  alignItems: 'center',
  width: 27,
  height: 50
};

export const styles = {
  separator: separatorStyles,
  container: containerStyles
};

export const inputWrapperStyles: StyleSystemProps = {
  _hover: {
    borderColor: 'mono14'
  },
  _focusWithin: {
    _after: {
      boxShadow: `0px 0 0px 2px #333333`
    }
  }
};

const startElementWrapperStyles: StyleSystemProps = {
  paddingLeft: pxToRem(10),
  paddingRight: 1
};

export const startElementEmptyWrapperStyles: StyleSystemProps = {
  ...startElementWrapperStyles,
  color: 'mono8'
};

export const startElementFilledWrapperStyles: StyleSystemProps = {
  ...startElementWrapperStyles,
  color: 'mono14'
};
